import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, Linking } from 'react-native';
import { useTranslation } from 'react-i18next';
import QText from './QText';
import RemainingTimeCountDown from './RemainingTimeCountDown';
import {
  getOnlyTimeAmPMFormat,
  showTimeZone,
  showDate,
  getTimeDifferenceInSeconds,
} from '../utils';

const NonBatchQueueInfo = ({ queueUserDetail, isAdmin = false, styles }) => {
  const { t } = useTranslation();
  const [isShowRemainingCount, setShowRemainingCount] = useState(false);

  // Status constants
  const HIDDEN_ESTIMATION_STATUSES = [
    'Buffer',
    'Removed',
    'Serving',
    'Exited',
    'Unconfirmed',
    'Completed',
  ];

  useEffect(() => {
    if (queueUserDetail) {
      if (queueUserDetail?.estimated_serving_start_datetime) {
        if (
          getTimeDifferenceInSeconds(
            queueUserDetail?.estimated_serving_start_datetime,
            queueUserDetail?.queue_timezone
          ) > 120
        ) {
          setShowRemainingCount(true);
        }
      }
    }
  }, [queueUserDetail]);

  // Helper methods
  const shouldShowEstimation = () => {
    return (
      !queueUserDetail?.start_time &&
      !HIDDEN_ESTIMATION_STATUSES.includes(queueUserDetail?.status)
    );
  };

  const isSkippedStatus = () => {
    return queueUserDetail?.status === 'Skipped';
  };

  if (queueUserDetail?.queue_type === 'Batch') {
    return null;
  }

  return (
    <>
      <View style={styles.infoContainerRow}>
        <QText style={styles.infoLableTxt}>{t('queue_name')}: </QText>
        <QText style={styles.infoHighLightTxt}>
          {queueUserDetail?.queue_name}
        </QText>
      </View>

      {/* Queue contact number - only show for user screen */}
      {!isAdmin && queueUserDetail?.queue_contact_number && (
        <View style={styles.infoContainerRow}>
          <QText style={styles.infoLableTxt}>
            {t('queue_contact_number')}:{' '}
          </QText>
          <TouchableOpacity
            style={{ flexDirection: 'row', alignItems: 'center' }}
            onPress={() =>
              Linking.openURL(`tel:${queueUserDetail?.queue_contact_number}`)
            }
          >
            <QText style={styles.mobileInfoHighLightTxt}>
              {queueUserDetail?.queue_contact_number}
            </QText>
          </TouchableOpacity>
        </View>
      )}

      {/* Status - only show for user screen */}
      {!isAdmin && queueUserDetail?.status && (
        <View style={styles.infoContainerRow}>
          <QText style={styles.infoLableTxt}>{t('status')} </QText>
          <QText style={styles.infoHighLightTxt}>
            {queueUserDetail?.status}
          </QText>
        </View>
      )}

      {queueUserDetail?.booking_datetime && (
        <View style={styles.infoContainerRow}>
          <QText style={styles.infoLableTxt}>{t('booking_date')}: </QText>
          <QText style={styles.infoHighLightTxt}>
            {showDate(queueUserDetail?.booking_datetime)}
          </QText>
        </View>
      )}

      {queueUserDetail?.queue_type === 'Appointment' && (
        <View style={styles.infoContainerRow}>
          <QText style={styles.infoLableTxt}>{t('slot_time')}: </QText>
          <QText style={styles.infoHighLightTxt}>
            {getOnlyTimeAmPMFormat(
              queueUserDetail?.booking_datetime,
              queueUserDetail?.queue_timezone
            )}
            {showTimeZone(queueUserDetail?.queue_timezone)
              ? ` ${queueUserDetail?.queue_timezone}`
              : ''}
          </QText>
        </View>
      )}

      {shouldShowEstimation() && (
        <>
          <View style={{ marginTop: 20 }}>
            {!isSkippedStatus() && isShowRemainingCount ? (
              <>
                {queueUserDetail?.estimated_serving_start_datetime && (
                  <View style={styles.infoContainerRow}>
                    <QText style={styles.infoLableTxt}>
                      {t('getting_serve_at')}{' '}
                    </QText>
                    <QText style={styles.infoHighLightTxt}>
                      {getOnlyTimeAmPMFormat(
                        queueUserDetail?.estimated_serving_start_datetime,
                        queueUserDetail?.queue_timezone
                      )}
                      {showTimeZone(queueUserDetail?.queue_timezone)
                        ? ' ' + showTimeZone(queueUserDetail?.queue_timezone)
                        : ''}
                    </QText>
                  </View>
                )}
                <View style={{ marginTop: 10 }}>
                  <QText style={styles.remainingTimeHeading}>
                    {t('remaining_time')}
                  </QText>
                  <View style={[styles.infoContainerRow, { marginTop: 10 }]}>
                    <RemainingTimeCountDown
                      estimationTime={
                        queueUserDetail?.estimated_serving_start_datetime
                      }
                      timezone={queueUserDetail?.queue_timezone}
                      timerComplete={() => setShowRemainingCount(false)}
                    />
                  </View>
                </View>
              </>
            ) : (
              <View style={styles.infoContainerRow}>
                <QText style={styles.infoHighLightTxt}>
                  {isAdmin
                    ? t('should_be_served_soon')
                    : t('you_will_be_serve_soon')}
                </QText>
              </View>
            )}
          </View>
        </>
      )}
    </>
  );
};

export default NonBatchQueueInfo;
